<template>
  <v-card>
    <v-card-title class="headline">
      <span>
        Export selected documents?
        <span class="grey--text subheading"></span>
      </span>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey darken-1" flat @click="$emit('close')">Cancel</v-btn>
      <download-excel :fetch="allocationBatchLines" type="csv" name="allocationBatch.csv">
        <v-btn
          :color="primaryNeutral"
          flat
          @click="dialog = false"
          :loading="loading"
        >Export Batches</v-btn>
      </download-excel>
    </v-card-actions>
  </v-card>
</template>

<script>
import AllocationService from "@/services/requests/allocationService";
import DownloadExcel from "vue-json-excel";
import FormatDates from "@/services/mixins/formatDates";
import BuildBatchQuery from "../mixins/buildBatchQuery";
export default {
  mixins: [FormatDates, BuildBatchQuery],
  components: {
    DownloadExcel
  },
  props: {
    selected: Array,
    selectedAll: Boolean
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async retrieveBatchLines() {
      const payload = this.buildQuery();
      payload.pagination = this.pagination;
      payload.csv = true;
      this.loading = true;
      try {
        const result = await AllocationService.getBatches(payload);
        return result.data.result;
      } catch (err) {
        return [];
      }
    },
    async allocationBatchLines() {
      let lines = await this.getAllocationBatchLines();
      lines = lines.map(line => {
        const driverProject = line.driver.driverProjects.find(
          ({ projectId }) =>
            projectId === line.allocationBatchHeader.site.project.id
        );
        return {
          Date: line.allocationBatchHeader.date,
          Site: line.allocationBatchHeader.site.name,
          Spoil: line.spoil.name,
          HeaderNotes: line.allocationBatchHeader.notes,
          TimeOfDay: line.allocationBatchHeader.day ? "Day" : "Night",
          StartTime: this.getUTCTime(line.startTime),
          TipName: line.tip.name,
          TipTSE: line.tip.number,
          Vehicle: line.vehicle.name,
          Driver: line.driver.name,
          "Driver Induction Card #": !!driverProject
            ? driverProject.cardNo
            : null,
          SubContractor: line.vehicle.contractor.name,
          LineNotes: line.notes
        };
      });
      this.loading = false;
      return lines;
    },
    async getAllocationBatchLines() {
      if (this.selectedAll) {
        return await this.retrieveBatchLines();
      } else {
        try {
          const result = await AllocationService.getBatchLinesByBatchIds({
            ids: this.selected.map(batch => batch.id)
          });
          return result.data.result;
        } catch (err) {}
      }
    }
  }
};
</script>

<style>
</style>